import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import { getCurrencySymbol } from '@gamiphy/utils/currency';
import { Trans } from '@gamiphy/react-i18n';
import { observer } from 'mobx-react';
import moneyIcon from '@gamiphy/loyalty-station-desktop/components/cashback/assets/money.jpg';
import { WelcomeGift, NoPhoneWelcomeGift } from '../components/cashback/cashbackProgram/loggedIn/components/welcomeGift';
import { ThemeStore } from '../store/theme';
import { Tabs } from '../store/ui';
import Tab from '../components/cashback/cashbackProgram/loggedIn/components/Tab';

const WelcomeGiftTab: React.FC = () => (
  <Tab
    tab={Tabs.WelcomeGift}
    header={(
      <Box display="flex" alignItems="center" gap={1}>
        <Box minWidth={35}>
          <Box
            height={29}
            px={0.5}
            display="flex"
            alignItems="center"
            justifyContent="center"
            color="#AF7228"
            sx={{
              background: `url(${moneyIcon})`, backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%',
            }}
          >
            <Typography
              fontSize={18}
              fontWeight={700}
            >
              {getCurrencySymbol()}
            </Typography>
          </Box>
        </Box>
        <Typography fontSize={16} fontWeight={700}>
          <Trans
            i18nKey="shared.welcomeGift"
            defaults="Welcome gift"
          />
        </Typography>
      </Box>
          )}
  >
    {!ThemeStore.theme.enableSmsFlow ? <NoPhoneWelcomeGift /> : <WelcomeGift /> }
  </Tab>
);

export default observer(WelcomeGiftTab);
